import {Pipe, PipeTransform} from "@angular/core";
import {Shipment} from "../services/shipment";
import {ShipmentProductLine} from "../services/shipment-product-line";

@Pipe({
    name: 'metaFilterAlt',
    standalone: true
})
export class MetaFilterPipeAlt implements PipeTransform {
    transform(allHeroes: ShipmentProductLine[], type?: string): ShipmentProductLine[] {
        let result = [];
        if (type === 'picking-complete') {
            result = allHeroes.filter(hero => hero.amount === hero.amount_picked);
        } if (type === 'picking-incomplete') {
            result = allHeroes.filter(hero => hero.amount !== hero.amount_picked);
        }

        return result;
    }
}
